export const ACTION_TYPES = {
  SET_FILTERS: 'SET_FILTERS',
  SET_IN_FILTER_FLOW: 'SET_IN_FILTER_FLOW',
  SET_ACTIVE_FILTER_STEP: 'SET_ACTIVE_FILTER_STEP',
  SET_TOTAL_HITS: 'SET_TOTAL_HITS',
  SET_SELECTED_RESULT_HEADER: 'SET_SELECTED_RESULT_HEADER',
  SET_SELECTED_PRIMARY_CLASSIFICATION: 'SET_SELECTED_PRIMARY_CLASSIFICATION',
  SET_SELECTED_SECONDARY_CLASSIFICATION: 'SET_SELECTED_SECONDARY_CLASSIFICATION',
  SET_SELECTED_HOTEL_PRODUCT: 'SET_SELECTED_HOTEL_PRODUCT',
  SET_SELECTED_CONCEPT_HOTEL: 'SET_SELECTED_CONCEPT_HOTEL',
  SET_SELECTED_RATING: 'SET_SELECTED_RATING',
  SET_SELECTED_PREFERENCE: 'SET_SELECTED_PREFERENCE',
  SET_SELECTED_LOCATION: 'SET_SELECTED_LOCATION',
  SET_SELECTED_FLIGHT_TIME: 'SET_SELECTED_FLIGHT_TIME',
  SET_SELECTED_TEMPERATURE_PERIOD: 'SET_SELECTED_TEMPERATURE_PERIOD',
  SET_SELECTED_TEMPERATURE: 'SET_SELECTED_TEMPERATURE',
  SET_SELECTED_NUMBER_OF_ADULTS: 'SET_SELECTED_NUMBER_OF_ADULTS',
  SET_SELECTED_NUMBER_OF_CHILDREN: 'SET_SELECTED_NUMBER_OF_CHILDREN',
  SET_SELECTED_DEPARTURE: 'SET_SELECTED_DEPARTURE',
  SET_SELECTED_DEPARTURE_MONTHS: 'SET_SELECTED_DEPARTURE_MONTHS',
};